import { isChunkLoadTimeout, loadWithRetry } from '@Sage/ssm-utils';

export const loadRichTextEditor = () =>
  loadWithRetry(() => import('./RichTextEditor'), {
    shouldRetry: isChunkLoadTimeout,
  });
